import { render } from "./GreenHouseClientForm.vue?vue&type=template&id=bad64eb4&scoped=true"
import script from "./GreenHouseClientForm.vue?vue&type=script&lang=js"
export * from "./GreenHouseClientForm.vue?vue&type=script&lang=js"

import "./GreenHouseClientForm.vue?vue&type=style&index=0&id=bad64eb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad64eb4"]])

export default __exports__